// Badge ufficiale Product Hunt. Nascosto finché non è configurato l'ID del post.
const POST_ID = process.env.REACT_APP_PH_POST_ID;
const POST_URL = process.env.REACT_APP_PH_URL;

export const ProductHuntBadge = ({ theme = "light", className = "" }) => {
  if (!POST_ID || !POST_URL) return null;
  return (
    <a
      href={POST_URL}
      target="_blank"
      rel="noreferrer"
      data-testid="product-hunt-badge"
      className={`inline-block transition-transform duration-200 hover:-translate-y-0.5 ${className}`}
    >
      <img
        src={`https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=${POST_ID}&theme=${theme}`}
        alt="Operativo AI - Featured on Product Hunt"
        width="250"
        height="54"
        style={{ width: 250, height: 54 }}
      />
    </a>
  );
};
